// Wallet identity and store selection are verified by the signed Shopify proxy.
export function startPoints({ document, window, fetch, AbortController, setTimeout, clearTimeout }) {
  const widgets = [...document.querySelectorAll('[data-mc-points]')];
  const hosts=['cargolet.mx','www.cargolet.mx','cargolet-tathagata.myshopify.com','mundo-cargolet-pruebas-2026.myshopify.com'];
  if (!widgets.length || !hosts.includes(window.location.hostname)) return;
  const production=window.location.hostname!=='mundo-cargolet-pruebas-2026.myshopify.com';
  const endpoint = '/apps/puntos-cargolet/cuenta/resumen';
  const money = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' });
  const points = new Intl.NumberFormat('es-MX', { maximumFractionDigits: 3 });
  let generation = 0, controller;
  const set = (widget, selector, text) => {
    const node = widget.querySelector(selector);
    if (node) node.textContent = text;
  };
  function reset(message = 'Consultar saldo') {
    for (const widget of widgets) {
      set(widget, '[data-points-balance]', message);
      set(widget, '[data-points-detail]', 'Entra a tu cuenta y únete para recibir el 2% en puntos.');
      set(widget, '[data-points-action]', widget.dataset.mcPoints === 'cart' ? 'Ver mis puntos' : 'Entrar a Mis puntos');
    }
  }
  function destination(ready) {
    for(const widget of widgets) {
      const link=widget.querySelector('[data-points-link]');
      if(link)link.href=ready?'/apps/puntos-cargolet/cuenta':'/pages/mis-puntos';
    }
  }
  function availability(ready) {
    document.querySelectorAll('[data-points-program-state]').forEach(node=>{node.textContent=ready?'El programa está disponible. Entra a Mis puntos y únete para empezar a acumular y canjear.':'Mis puntos no está disponible en este momento. Vuelve a intentarlo más tarde.';});
  }
  async function refresh() {
    const current = ++generation;
    controller?.abort(); controller = new AbortController();
    const thisController = controller;
    reset('Consultando saldo…');destination(false);
    const timeout = setTimeout(() => thisController.abort(), 15000);
    try {
      const response = await fetch(endpoint, { credentials: 'same-origin', cache: 'no-store', signal: thisController.signal });
      if(response.status===404)throw new Error('not_active');
      const data = await response.json();
      if(data.pointsActive===false)throw new Error('not_active');
      if(!response.ok || production&&data.production!==true)throw new Error('unavailable');
      if (current !== generation || document.hidden) return;
      if(typeof data.signedIn!=='boolean'||typeof data.enrolled!=='boolean')throw new Error('invalid');
      destination(true);availability(true);
      if (data.signedIn === false && data.enrolled === false) { reset('Entra y gana el 2%'); return; }
      if (data.signedIn !== true) throw new Error('invalid');
      if (data.enrolled === false) {
        for (const widget of widgets) {
          set(widget, '[data-points-balance]', 'Únete y gana el 2%');
          set(widget, '[data-points-detail]', 'Ya tienes tu cuenta. Activa tu participación sin volver a dar tu domicilio.');
          set(widget, '[data-points-action]', 'Unirme al programa');
        }
        return;
      }
      if (data.enrolled !== true || !Number.isSafeInteger(data.balanceUnits) || !Number.isSafeInteger(data.availableCents) || data.availableCents !== Math.max(0, Math.floor(data.balanceUnits / 100)) || typeof data.hasRedemption !== 'boolean') throw new Error('invalid');
      for (const widget of widgets) {
        set(widget, '[data-points-balance]', `${points.format(Math.max(0, data.balanceUnits) / 1000)} puntos · ${money.format(data.availableCents / 100)} MXN`);
        set(widget, '[data-points-detail]', data.hasRedemption ? 'Tienes un descuento reservado. Recupéralo sin volver a gastar puntos.' : data.balanceUnits < 0 ? 'Tienes un ajuste por devolución. Consulta los movimientos en Mis puntos.' : 'Tus compras de productos participantes suman el 2%. Elige el importe antes de confirmar tu canje.');
        set(widget, '[data-points-action]', data.hasRedemption ? 'Aplicar mi descuento' : widget.dataset.mcPoints === 'cart' && data.availableCents > 0 ? 'Usar mis puntos' : 'Ver saldo e historial');
      }
    } catch (error) {
      if (current === generation) {
        destination(false);
        const inactive=error.message==='not_active';
        if(inactive)availability(false);
        reset(inactive?'Programa no disponible':'Saldo no disponible');
        for (const widget of widgets) set(widget, '[data-points-detail]', inactive?'No pudimos confirmar la disponibilidad del programa. Puedes consultar sus reglas y volver a intentarlo más tarde.':'No pudimos consultar tu saldo. Vuelve a cargar Mis puntos para intentarlo de nuevo.');
      }
    } finally { clearTimeout(timeout); }
  }
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) { generation++; controller?.abort(); reset();destination(false); }
    else refresh();
  });
  window.addEventListener('pagehide', () => { generation++; controller?.abort(); reset();destination(false); });
  window.addEventListener('pageshow', event => { if (event.persisted) refresh(); });
  refresh();
  return { refresh };
}
if (typeof document !== 'undefined') startPoints({ document, window, fetch: window.fetch.bind(window), AbortController, setTimeout, clearTimeout });
